import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';
import { Province } from '../../shared/models/province.model';
import {Observable} from 'rxjs';
import {ApiConfigService} from './api.config.service';
import {map} from 'rxjs/operators';

export type ProvinceResponse = {
  data: Province[];
}

@Injectable({providedIn: 'root'})
export class ProvinceService {
  constructor(
    private http: HttpClient,
    private cache: HttpCacheService,
    private apiConfigService: ApiConfigService,
  ) {
  }

  getProvinces(): Observable<Province[]> {
    const url = this.apiConfigService.getProvincesUrl();
    const key = `ProvincesService:GET:${url}`;
    return this.cache.getOrSet<ProvinceResponse>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<ProvinceResponse>(url)
    ).pipe(
      map((res) => Array.isArray(res.data) ? res.data : [])
    )
  }

}
